import { type FC, type ReactNode } from 'react';

import clsx from 'clsx';

import { Flex } from '@/components/common/Flex';
import { Text } from '@/components/common/Text';
import { type WithClassName } from '@/types/react';

import styles from './Chart.module.scss';

type ChartProps = WithClassName & {
  chartClassName?: string;
  title: ReactNode;
  filter: ReactNode;
  chart: ReactNode;
};

export const Chart: FC<ChartProps> = (props) => {
  const { className, chartClassName, title, filter, chart } = props;

  return (
    <Flex className={clsx(styles.root, className)} direction="column">
      <Flex className={styles.header} direction="column" gap={6}>
        <Text className={styles.title} type="medium18">
          {title}
        </Text>

        {filter}
      </Flex>

      <div className={clsx(styles.chart, chartClassName)}>{chart}</div>
    </Flex>
  );
};
